<app-modal-component [open]="openModal" label="Edit goals">
  <div class="cf-shell cf-shell--narrow">
    <app-form-wrapper title="Goals" (iconClick)="onClose.emit()" icon="close">
      <form class="cf" [formGroup]="goalsForm" (ngSubmit)="onSubmit()" novalidate>
        <p class="cf__lead">What should this campaign achieve? Keep each goal to one line.</p>

        <div class="cf__stack" formArrayName="goals">
          @for (goal of goals.controls; track goal; let i = $index) {
            <div class="cf__row">
              <input-field
                [label]="'Goal ' + (i + 1)"
                [errorMessage]="submitted && goal.invalid ? 'Write this goal, or remove it.' : ''"
              >
                <input
                  class="input-style"
                  [formControlName]="i"
                  placeholder="For example, 500 sign-ups by Friday"
                />
              </input-field>

              <!-- delete button -->
              @if ($count > 1) {
                <button
                  type="button"
                  class="bk-icon-btn"
                  [attr.aria-label]="'Remove goal ' + (i + 1)"
                  matTooltip="Remove goal"
                  (click)="removeGoal(i)"
                >
                  <span class="bk-sym" aria-hidden="true">close</span>
                </button>
              }
            </div>
          }
        </div>

        <!-- add another goal -->
        <button type="button" class="bk-btn bk-btn--ghost cf__add" (click)="addGoal()">
          <span class="bk-sym" aria-hidden="true">add</span>
          Add another goal
        </button>

        <!-- save changes -->
        <div class="cf__foot">
          <customizable-button title="Cancel" [outline]="true" (click)="onClose.emit()" type="button" />
          <customizable-button title="Save goals" type="submit" [loading]="campaignsService.isLoading" />
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
